import type { Row, Table } from '@tanstack/react-table'

/**
 * Whether a row is the last one of its group in a table with expandable rows:
 * a collapsed parent, or the final child of an expanded parent. Those rows get
 * the heavier bottom rule. A flat table has no groups, so no row qualifies.
 */
export function closesRowGroup<T>(row: Row<T>, table: Table<T>): boolean {
  if (!table.getCanSomeRowsExpand()) return false
  if (row.depth === 0) return !row.getIsExpanded()
  const parent = row.getParentRow()
  return !!parent?.getIsExpanded() && parent.subRows.at(-1)?.id === row.id
}
